import { fnTaxableAmt, fnTaxAmt } from "../General/Formula";

const round2 = (n) => {
  const x = Number(n);
  return Number.isFinite(x) ? Math.round((x + Number.EPSILON) * 100) / 100 : 0;
};

const itemTaxLines = (Item) => {
  const rel = Number(Item.iTaxRelId);
  const level = Item.TaxLvl ?? Item.taxLvl ?? 1;
  const lines = [];
  if (rel === 1) {
    lines.push({
      TaxDesc: Item.strSGST,
      TaxId: Item.iSGST,
      TaxPer: Number(Item.strSGSTPer) || 0,
      Level: level,
    });
    lines.push({
      TaxDesc: Item.strCGST,
      TaxId: Item.iCGST,
      TaxPer: Number(Item.strCGSTPer) || 0,
      Level: level,
    });
  } else if (rel === 2) {
    lines.push({
      TaxDesc: Item.strIGST,
      TaxId: Item.iIGST,
      TaxPer: Number(Item.strIGSTPer) || 0,
      Level: level,
    });
  } else if (Number(Item.TaxPer) > 0) {
    lines.push({
      TaxDesc: Item.TaxDesc || Item.strTaxDesc || "GST",
      TaxId: Item.iTaxId || Item.TaxId || 0,
      TaxPer: Number(Item.TaxPer) || 0,
      Level: level,
    });
  }
  return lines.filter((line) => Number(line.TaxId) || Number(line.TaxPer));
};

const GSTTaxCalculation = (EntDT, EntAL, ALTax, OthCalWQty, iTaxCalcOnId) => {
  const taxCalcOn = Number(iTaxCalcOnId);
  const withQty =
    OthCalWQty === "Yes" ||
    OthCalWQty === 1 ||
    OthCalWQty === "1" ||
    OthCalWQty === true;
  const objTaxDetails = [];

  (EntDT || []).forEach((Item) => {
    const dQty = Math.abs(Number(Item.Qty) || 0);
    const dRateWithoutTax = Number(Item.RateWithoutTax) || 0;
    const dFinalVal = Number(Item.FinalValue) || 1;
    const base = withQty
      ? dQty * dRateWithoutTax * dFinalVal
      : dQty * dRateWithoutTax;
    const taxable = round2(
      fnTaxableAmt(
        taxCalcOn,
        base,
        Number(Item.ItemDiscValue) || 0,
        Number(Item.CashDiscValue) || 0,
        Number(Item.BillDiscValue) || 0
      )
    );
    itemTaxLines(Item).forEach((line) => {
      objTaxDetails.push({
        ...line,
        TaxableAmt: taxable,
        TaxAmt: round2(fnTaxAmt(line.TaxPer, taxable)),
      });
    });
  });

  const alTaxes = JSON.parse(JSON.stringify(ALTax || []));
  (EntAL || []).forEach((ALItem) => {
    alTaxes.forEach((tax) => {
      if (ALItem.serId !== tax.serId) return;
      const taxable = round2(
        fnTaxableAmt(taxCalcOn, Number(ALItem.rateWithoutTax) || 0, 0, 0, 0)
      );
      objTaxDetails.push({
        TaxDesc: tax.taxDesc,
        TaxableAmt: taxable,
        TaxAmt: round2(fnTaxAmt(Number(tax.taxPer) || 0, taxable)),
        TaxId: tax.taxId,
        TaxPer: Number(tax.taxPer) || 0,
        Level: tax.level,
      });
    });
  });

  const helper = {};
  const TaxGroup = [];
  objTaxDetails.forEach((row) => {
    const key = `${row.TaxId}-${row.TaxDesc}-${row.TaxPer}`;
    if (!helper[key]) {
      helper[key] = {
        taxDesc: row.TaxDesc,
        taxableAmt: 0,
        taxAmt: 0,
        taxId: row.TaxId,
        taxPer: row.TaxPer,
        level: row.Level,
      };
      TaxGroup.push(helper[key]);
    }
    helper[key].taxableAmt = round2(
      helper[key].taxableAmt + (Number(row.TaxableAmt) || 0)
    );
    helper[key].taxAmt = round2(helper[key].taxAmt + (Number(row.TaxAmt) || 0));
  });

  return {
    _objBaseTransDT: EntDT,
    _objEntTransTax: objTaxDetails,
    _objEntTaxGrp: TaxGroup,
  };
};

export default GSTTaxCalculation;
